"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CQATaskCodes_1 = __importDefault(require("./CQATaskCodes"));
var vanillaDiagnosis = CQATaskCodes_1.default.vanillaDiagnosis, vanillaModifier = CQATaskCodes_1.default.vanillaModifier, vanillaProcedure = CQATaskCodes_1.default.vanillaProcedure;
var CodeLessTransaction = {
    id: 1,
    sequenceNumber: 1,
    procedures: [],
    diagnoses: [],
    modifiers: [],
    original: true
};
var Transaction = {
    id: 1,
    sequenceNumber: 1,
    procedures: [vanillaProcedure],
    diagnoses: [vanillaDiagnosis],
    modifiers: [vanillaModifier],
    original: true
};
var IncorrectTransaction = {
    id: 1,
    sequenceNumber: 1,
    procedures: [
        __assign(__assign({}, vanillaProcedure), { codeAssessment: { assessment: "NOT DOCUMENTED", role: "CODABLE", id: 1 } })
    ],
    diagnoses: [
        __assign(__assign({}, vanillaDiagnosis), { codeAssessment: { assessment: "INVALID AS PRIMARY", role: "ERROR", id: 1 } })
    ],
    modifiers: [
        __assign(__assign({}, vanillaModifier), { codeAssessment: {
                assessment: "INCREASED PROCEDURAL SERVICE",
                role: "PAYMENT",
                id: 1
            } })
    ],
    original: true
};
var NonOriginalTransaction = {
    id: 2,
    sequenceNumber: 2,
    procedures: [vanillaProcedure],
    diagnoses: [vanillaDiagnosis],
    modifiers: [vanillaModifier],
    original: false
};
var GradeableTransactionFixtures = {
    CodeLessTransaction: CodeLessTransaction,
    Transaction: Transaction,
    IncorrectTransaction: IncorrectTransaction,
    NonOriginalTransaction: NonOriginalTransaction
};
exports.default = GradeableTransactionFixtures;
//# sourceMappingURL=GradeableTransaction.js.map